import React, {useEffect, useState} from 'react';
import IconTextView from "components/input/IconTextView";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import messages from "res/messages/farsi";
import queryString from 'query-string';
import Space from "../../../components/space/Space";
import {Divider} from "@material-ui/core";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import {useHistory} from "react-router-dom";
import {getButtonHeight, getTextViewHeight, IsF, IsM, IsSM, IsT} from "my-styles/media/media";

import ICInviteFriend from "res/images/invite_friend_desktop.png";
import ICFantasticBg2 from "res/images/fantastic_bg_2.png";
import ICDoneIcon from "res/images/done_white.png";
import ICPhone from "res/images/phone.png";

export default function InvitedByFriend(props) {

    const history = useHistory()

    const [phone, setPhone] = useState("")
    const [agentCode, setAgentCode] = useState("")

    function requestFinalizeInvitation() {
        let params = new FormData()
        params.append("telephone", phone)
        params.append("agent_code", agentCode)
        callApi(Urls.registerAgentByLink, params, () => {
                props.onNavigate(history, "/verify", {
                    invitedCode: agentCode, telephone: phone,
                    fromInvitePage: true
                })
            }, (data) => {
                if (data.description === 103) {
                    props.onAlert(messages.wrongPhoneNumber)
                } else if (data.description === 104) {
                    props.onAlert(messages.timeVerifyCodeError)
                } else if (data.description === 105) {
                    props.onAlert(messages.sendVerifyCodeError)
                } else if (data.description === 111) {
                    props.onAlert(messages.youreBeforeRegister)
                } else if (data.description === 112) {
                    props.onAlert(messages.youreBeforeInvited)
                } else {
                    props.onAlert(messages.responseCodeIsNot200)
                }
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            }
        )
    }

    useEffect(() => {
        if (props && props.location && props.location.search) {
            let urlParams = queryString.parse(props.location.search)
            if (urlParams) {
                setAgentCode(urlParams.agentCode)
            }
        }
    }, [props])

    return (IsSM() || IsM() ?
        <div className="marginSmall" style={{
            backgroundImage: 'url(' + ICFantasticBg2 + ')',
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <table className="fullWidth center" style={{height: "35em"}}>
                <tbody>
                <tr>
                    <td>
                        <center>
                            <div style={{width: "60%"}} className="largeTextBold">
                                {messages.user + " " + agentCode + " " + messages.userInviteYou}
                            </div>
                            <Space/>
                            <Divider style={{width: "60%"}}/>
                            <div style={{width: "60%"}} className="grayColor">
                                {messages.forExample}
                            </div>
                            <Divider style={{width: "60%"}}/>
                            <Space height={"1.5em"}/>
                            <div style={{width: "60%"}} className="marginTopMedium">
                                <IconTextView
                                    height={getTextViewHeight()}
                                    placeholder={messages.telephone}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                    onChange={(e) => {
                                        setPhone(e.target.value)
                                    }}/>
                            </div>
                            <div style={{width: "60%"}} className="marginTopMedium">
                                <IconTitleButtonRound
                                    height={getButtonHeight()}
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        requestFinalizeInvitation()
                                    }}
                                    icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                    title={messages.enter}/>
                            </div>
                        </center>
                    </td>
                </tr>
                </tbody>
            </table>
        </div> :
        IsF() ?
            <div className="marginSmall" style={{
                marginTop: "10em",
                backgroundImage: 'url(' + ICFantasticBg2 + ')',
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat"
            }}>
                <table className="fullWidth center" style={{height: "35em"}}>
                    <tbody>
                    <tr>
                        <td>
                            <center>
                                <div style={{width: "55%"}} className="largeTextBold">
                                    {messages.user + " " + agentCode + " " + messages.userInviteYou}
                                </div>
                                <Space/>
                                <Divider style={{width: "55%"}}/>
                                <div style={{width: "55%"}} className="grayColor">
                                    {messages.forExample}
                                </div>
                                <Divider style={{width: "55%"}}/>
                                <Space height={"1.5em"}/>
                                <div style={{width: "55%"}} className="marginTopMedium">
                                    <IconTextView
                                        height={getTextViewHeight()}
                                        placeholder={messages.telephone}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                        onChange={(e) => {
                                            setPhone(e.target.value)
                                        }}/>
                                </div>
                                <div style={{width: "55%"}} className="marginTopMedium">
                                    <IconTitleButtonRound
                                        height={getButtonHeight()}
                                        fontSize="mediumTextBold"
                                        onClick={() => {
                                            requestFinalizeInvitation()
                                        }}
                                        icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                        title={messages.enter}/>
                                </div>
                            </center>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div> :
            IsT() ?
                <div className="marginSmall" style={{
                    marginTop: "10em",
                    backgroundImage: 'url(' + ICFantasticBg2 + ')',
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                }}>
                    <table className="fullWidth center" style={{height: "35em"}}>
                        <tbody>
                        <tr>
                            <td>
                                <center>
                                    <div style={{width: "40%"}} className="largeTextBold">
                                        {messages.user + " " + agentCode + " " + messages.userInviteYou}
                                    </div>
                                    <Space/>
                                    <Divider style={{width: "40%"}}/>
                                    <div style={{width: "40%"}} className="grayColor">
                                        {messages.forExample}
                                    </div>
                                    <Divider style={{width: "40%"}}/>
                                    <Space height={"1.5em"}/>
                                    <div style={{width: "40%"}} className="marginTopMedium">
                                        <IconTextView
                                            height={getTextViewHeight()}
                                            placeholder={messages.telephone}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                            onChange={(e) => {
                                                setPhone(e.target.value)
                                            }}/>
                                    </div>
                                    <div style={{width: "40%"}} className="marginTopMedium">
                                        <IconTitleButtonRound
                                            height={getButtonHeight()}
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestFinalizeInvitation()
                                            }}
                                            icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon} className="marginSmall xSmallIcon"/>}
                                            title={messages.enter}/>
                                    </div>
                                </center>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div> :
                <div className="horizontalFullScreen">
                    <div className="formContainerLarge marginTopBottomMedium">
                        <img className="lowZIndex fullWidth" style={{height: "90%"}} src={ICFantasticBg2} alt=""/>
                        <table className="full " style={{position: "absolute", top: "0"}}>
                            <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <div className="halfWidth largeTextBold">
                                            {messages.user + " " + agentCode + " " + messages.userInviteYou}
                                        </div>
                                        <Space/>
                                        <Divider className="halfWidth"/>
                                        <div className="halfWidth grayColor">
                                            {messages.forExample}
                                        </div>
                                        <Divider className="halfWidth"/>
                                        <Space className="halfWidth" height={"1.5em"}/>
                                        <div className="halfWidth marginTopMedium">
                                            <IconTextView
                                                height={getTextViewHeight()}
                                                placeholder={messages.telephone}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICPhone} className="marginSmall xSmallIcon"/>}
                                                onChange={(e) => {
                                                    setPhone(e.target.value)
                                                }}/>
                                        </div>
                                        <div className="halfWidth marginTopMedium">
                                            <IconTitleButtonRound
                                                height={getButtonHeight()}
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestFinalizeInvitation()
                                                }}
                                                icon={<img alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"} src={ICDoneIcon}
                                                           className="marginSmall xSmallIcon"/>}
                                                title={messages.enter}/>
                                        </div>
                                    </center>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="imageContainer">
                        <img className="leftSideBg" src={ICInviteFriend} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>
                    </div>
                </div>)

}